import { SvgIcon } from "@mui/material";
import { ReactComponent as OverviewIcon } from "./../Icons/Overview.svg";
import { ReactComponent as ApplicationsIcon } from "./../Icons/Applications.svg";
import { ReactComponent as ResearchersIcon } from "./../Icons/Researchers.svg";
import { ReactComponent as GranteesIcon } from "./../Icons/Grantees.svg";
import { ReactComponent as PreGranteesIcon } from "./../Icons/PreGrantees.svg";
import { ReactComponent as FormsIcon } from "./../Icons/Forms.svg";


export const Overview = (props) => (
  <SvgIcon {...props} component={OverviewIcon} viewBox="0 0 18 18" />
);
export const Applicantions = (props) => (
  <SvgIcon {...props} component={ApplicationsIcon} viewBox="0 0 18 18" />
);
export const Researchers = (props) => (
  <SvgIcon {...props} component={ResearchersIcon} viewBox="0 0 18 18" />
);
export const Grantees = (props) => (
  <SvgIcon {...props} component={GranteesIcon} viewBox="0 0 18 18" />
);
export const PreGrantees = (props) => (
  <SvgIcon {...props} component={PreGranteesIcon} viewBox="0 0 18 18" />
);
export const Forms = (props) => (
  <SvgIcon {...props} component={FormsIcon} viewBox="0 0 18 18" />
);

